import ConfigStore from 'stores/config/ConfigStore'

interface IShortcut {
  name: string
  mac: string[]
  windowsAndLinux: string[]
}

interface IShortcutSection {
  name: string
  shortcuts: IShortcut[]
  section?: IShortcutSection
}

interface IShortcutList {
  sections: IShortcutSection[]
}

const getShortcuts = (): IShortcutList => {
  const sections: (IShortcutSection | null)[] = [
    {
      name: 'Results Table',
      shortcuts: [
        {
          name: 'Move cell selection',
          mac: ['←', '→', '↑', '↓'],
          windowsAndLinux: ['←', '→', '↑', '↓'],
        },
        {
          name: 'Move horizontally',
          mac: ['tab', 'shift+tab'],
          windowsAndLinux: ['tab', 'shift+tab'],
        },
        {
          name: 'Move vertically',
          mac: ['enter', 'shift+enter'],
          windowsAndLinux: ['enter', 'shift+enter'],
        },
        {
          name: 'Edit selected cell',
          mac: ['enter'],
          windowsAndLinux: ['enter'],
        },
        {
          name: 'Jump to last cell in row',
          mac: ['⌘+→'],
          windowsAndLinux: ['ctrl+→'],
        },
        {
          name: 'Jump to first cell in row',
          mac: ['⌘+←'],
          windowsAndLinux: ['ctrl+←'],
        },
        {
          name: 'Copy selected rows to clipboard as JSON',
          mac: ['⌘+c'],
          windowsAndLinux: ['ctrl+c'],
        },
        {
          name: 'Delete selected rows',
          mac: ['⌫'],
          windowsAndLinux: ['del'],
        },
        {
          name: 'Commit unsaved changes to Database',
          mac: ['⌘+s'],
          windowsAndLinux: ['ctrl+s'],
        },
      ],
    },
    ConfigStore.isBrowser
      ? null
      : {
          name: 'Tabs',
          shortcuts: [
            {
              name: 'Switch to tab on the left',
              mac: ['⌘+shift+['],
              windowsAndLinux: ['ctrl+tab'],
            },
            {
              name: 'Switch to tab on the right',
              mac: ['⌘+shift+]'],
              windowsAndLinux: ['ctrl+shift+tab'],
            },
          ],
        },

    {
      name: 'Global',
      shortcuts: [
        {
          name: 'Show this cheatsheet',
          mac: ['⌘+/'],
          windowsAndLinux: ['ctrl+/'],
        },
      ],
    },
  ]

  return {
    sections: sections.filter((s): s is IShortcutSection => !!s),
  }
}

export default getShortcuts
